// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"app_spinnerWrapper__mH8vc"};